export default {"src":"/_next/static/media/step1g.ac586a74.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};